exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn.dropdown-toggle[data-v-5b8330ea],.dropdown-menu[data-v-5b8330ea]{min-width:13rem;max-width:13rem}.dropdown-item[data-v-5b8330ea],.dropdown-toggle[data-v-5b8330ea]{text-transform:uppercase}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5b8330ea","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/tables/vuetable-2/datatable-components/ItemsPerPage.vue
// module id = 616
// module chunks = 27